import { render, staticRenderFns } from "./SetupSecureAccessMenu.vue?vue&type=template&id=2596e7db&scoped=true&"
import script from "./SetupSecureAccessMenu.vue?vue&type=script&lang=js&"
export * from "./SetupSecureAccessMenu.vue?vue&type=script&lang=js&"
import style0 from "./SetupSecureAccessMenu.vue?vue&type=style&index=0&id=2596e7db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596e7db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2596e7db')) {
      api.createRecord('2596e7db', component.options)
    } else {
      api.reload('2596e7db', component.options)
    }
    module.hot.accept("./SetupSecureAccessMenu.vue?vue&type=template&id=2596e7db&scoped=true&", function () {
      api.rerender('2596e7db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/SetupSecureAccessMenu.vue"
export default component.exports